import React from 'react';
import { Target, Eye, Award } from 'lucide-react';
import { companyInfo } from '../data/mock';

const AboutSection = () => {
  return (
    <section id="about" className="dark-container py-20">
      <div className="dark-content-container">
        <div className="text-center mb-16">
          <h2 className="display-large mb-6">About NFIT Corp</h2>
          <p className="body-large max-w-4xl mx-auto">
            {companyInfo.description}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 mb-20">
          {/* Mission */}
          <div className="text-center space-y-6 p-8 rounded-lg" style={{ 
            background: 'rgba(255, 255, 255, 0.05)',
            border: '1px solid rgba(255, 255, 255, 0.1)'
          }}>
            <div className="mx-auto w-16 h-16 rounded-full flex items-center justify-center" style={{ 
              background: 'rgba(0, 255, 209, 0.2)' 
            }}>
              <Target size={32} style={{ color: '#00FFD1' }} />
            </div>
            <h3 className="heading-2">Our Mission</h3>
            <p className="body-medium">
              To digitally empower businesses and organizations across the MENA region by delivering cutting-edge IoT, Blockchain, and AI solutions that drive transformation and growth.
            </p>
          </div>

          {/* Vision */}
          <div className="text-center space-y-6 p-8 rounded-lg" style={{ 
            background: 'rgba(255, 255, 255, 0.05)',
            border: '1px solid rgba(255, 255, 255, 0.1)'
          }}>
            <div className="mx-auto w-16 h-16 rounded-full flex items-center justify-center" style={{ 
              background: 'rgba(0, 255, 209, 0.2)' 
            }}>
              <Eye size={32} style={{ color: '#00FFD1' }} />
            </div>
            <h3 className="heading-2">Our Vision</h3>
            <p className="body-medium">
              To become the leading technology solutions provider in the MENA region, creating innovative and sustainable digital solutions that position the region as a global leader in digital transformation.
            </p>
          </div>

          {/* Values */}
          <div className="text-center space-y-6 p-8 rounded-lg" style={{ 
            background: 'rgba(255, 255, 255, 0.05)',
            border: '1px solid rgba(255, 255, 255, 0.1)'
          }}>
            <div className="mx-auto w-16 h-16 rounded-full flex items-center justify-center" style={{ 
              background: 'rgba(0, 255, 209, 0.2)' 
            }}>
              <Award size={32} style={{ color: '#00FFD1' }} />
            </div>
            <h3 className="heading-2">Our Values</h3>
            <p className="body-medium">
              Excellence, Innovation, Trust, and Partnership. We believe in building long-term relationships with our clients and delivering solutions that exceed expectations.
            </p>
          </div>
        </div>

        {/* Company Heritage */}
        <div className="text-center p-12 rounded-lg" style={{ 
          background: 'rgba(0, 255, 209, 0.05)',
          border: '1px solid rgba(0, 255, 209, 0.2)'
        }}>
          <h3 className="heading-1 mb-4">Sister Company of NF Infratech</h3>
          <p className="body-large max-w-4xl mx-auto">
            Building on 15+ years of excellence in digital transformation across India, NFIT Corp brings proven expertise and innovative solutions to the MENA region. Our founding team combines deep industry knowledge with local market understanding to deliver exceptional results.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;